import withAPIAction from 'helpers/withAPIAction'
import {
  LoginReq,
  ResetPasswordReq,
  VerifyTokenReq,
  UpdatePasswordReq,
  MyMerchantReq,
  RegisterTokenReq,
  RegisterAccountReq,
  StaffLoginReq,
  StaffPermissionReq,
  RefreshTokenReq,
} from './types'
import {
  loginAction,
  resetPasswordAction,
  verifyTokenAction,
  updatePasswordAction,
  getMyMerchantsAction,
  findRegisterTokenAction,
  registerAccountAction,
  staffLoginAction,
  getStaffPermissionAction,
  refreshTokenAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const loginAPI = (data: LoginReq) => {
  return withAPIAction<LoginReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.login,
    data,
  })(loginAction)
}

export const stafflLoginAPI = (data: StaffLoginReq) => {
  return withAPIAction<StaffLoginReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.staffLogin,
    data,
  })(staffLoginAction)
}

export const staffPermissionAPI = (data: StaffPermissionReq, token: string, xmid: any) => {
  return withAPIAction<StaffPermissionReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.staffPermission,
    data,
    token,
    xmid,
  })(getStaffPermissionAction)
}

export const merchantPermissionAPI = (data: StaffPermissionReq, token: string, xmid: any) => {
  return withAPIAction<StaffPermissionReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.merchantPermission,
    data,
    token,
    xmid,
  })(getStaffPermissionAction)
}

export const resetPasswordAPI = (data: ResetPasswordReq) => {
  return withAPIAction<ResetPasswordReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.resetPassword,
    data,
  })(resetPasswordAction)
}

export const verifyTokenAPI = (data: VerifyTokenReq) => {
  return withAPIAction<VerifyTokenReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.verifyToken,
    data,
  })(verifyTokenAction)
}

export const updatePasswordAPI = (data: UpdatePasswordReq) => {
  return withAPIAction<UpdatePasswordReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updatePassword,
    data,
  })(updatePasswordAction)
}

export const myMerchantsAPI = (data: MyMerchantReq, token: string) => {
  return withAPIAction<MyMerchantReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.myMerchants,
    data,
    token,
  })(getMyMerchantsAction)
}

export const staffMerchantsAPI = (data: MyMerchantReq, token: string) => {
  return withAPIAction<MyMerchantReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.staffMerchants,
    data,
    token,
  })(getMyMerchantsAction)
}

export const findRegisterTokenAPI = (data: RegisterTokenReq) => {
  return withAPIAction<RegisterTokenReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.findRegisterToken,
    data,
  })(findRegisterTokenAction)
}

export const registerNewAccountAPI = (data: RegisterAccountReq) => {
  return withAPIAction<RegisterAccountReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.registerNewAccount,
    data,
  })(registerAccountAction)
}

export const refreshTokenAPI = (data: RefreshTokenReq, token: string) => {
  return withAPIAction<RefreshTokenReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.refreshToken,
    token,
    data,
  })(refreshTokenAction)
}
